import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

import { paper } from 'app/styles/core';

import FormBuilder from 'app/components/form/FormBuilder';

import useApp from 'app/context/useApp';
import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    paper: {
        ...paper(theme),
        marginBottom: theme.spacing(3)
    },
    marginTop: {
        marginTop: theme.spacing(3)
    },
    divider: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3)
    },
    saveButtonContainer: {
        marginTop: theme.spacing(3)
    },
    saveButton: {
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
    },
}));

export default function Fields(props) {

    const { app } = useApp();
    const api = useApi();
    const classes = useStyles();

    const [ loading, setLoading ] = useState(false);
    const [ fields, setFields ] = useState([]);
    const [ errors, setErrors ] = useState({});

    useEffect(() => {
        if (app.club?.fields?.length > 0) setFields([...app.club.fields]);
    }, [app.club]);

    const postFields = () => {
        setLoading(true);

        api.post(`/admin/club/fields`, {fields: fields})
            .catch((error) => {
                if (error?.response?.data?.errors) {
                    setErrors(error.response.data.errors)
                }
            }).finally(() => setLoading(false));
    }

    return (
        <form noValidate autoComplete="off">
            <Paper className={classes.paper}>
                <Grid container
                    alignItems="center"
                    justify="space-between"
                    spacing={3}
                    >
                    <Grid item>
                        <Typography variant="h6" component="h2" gutterBottom>
                            Custom Fields
                        </Typography>
                    </Grid>
                </Grid>
                <Typography color="textSecondary">
                   Create custom fields for your organization to expand the usability of the Club Apps platform. Fields can be toggled to be admin only or displayed to the user.
                </Typography>
            </Paper>
            <Paper className={classes.paper}>
                <Grid container
                    alignItems="center"
                    justify="space-between"
                    spacing={3}
                    >
                    <Grid item>
                        <Typography variant="h6" component="h3" gutterBottom>
                            User Fields
                        </Typography>
                    </Grid>
                </Grid>
                <FormBuilder custom fields={fields} setFields={setFields} errors={errors} />
                <Typography align="right" component="div" className={classes.saveButtonContainer}>
                    <Button
                        disabled={loading}
                        variant="contained"
                        color="primary"
                        className={classes.saveButton}
                        size="small"
                        onClick={postFields}
                        >
                        save
                    </Button>
                </Typography>
            </Paper>
        </form>
    )
}
